export default function DropArea() {
    return <div className="droparea">
        <div>
            ここにカードをドロップして追加
        </div>
    </div>
}